import { enumToList } from '..';
import { Pipe, PipeTransform } from '@angular/core';
import { PeFormResponse } from '../../enums/pe-form-response.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'peFormResponse',
  standalone: false
})
export class PeFormResponsePipe implements PipeTransform {
  public transform(value: PeFormResponse): string {
    return getPeFormResponse(value);
  }
}

export function getPeFormResponse(value: PeFormResponse): string {
  switch (value) {
    case PeFormResponse.Create:
      return 'Created';
    case PeFormResponse.Submit:
      return 'Submitted';
    case PeFormResponse.Accept:
      return 'Accepted';
    case PeFormResponse.Reject:
      return 'Rejected';
    case PeFormResponse.AutoReject:
      return 'Auto-Rejected';
    case PeFormResponse.Override:
      return 'Overridden';
    case PeFormResponse.Updated:
      return 'Updated';
    default:
      throw new Error(`Unsupported value for Response: ${value}.`);
  }
}

export function getPeFormResponseList(): IdName[] {
  return enumToList(PeFormResponse, getPeFormResponse);
}
